'use client';

import { useSelector } from 'react-redux';
import Conditional from '@next-app/components/Conditional';
import SkeletonUI from '@next-app/components/Skeleton/Skeleton';
import dynamic from 'next/dynamic';
import {
  selectShowShippingMethodStep,
  selectIsCheckoutDetailsLoaded,
  selectIsPureDigitalOrder,
} from '@next-app/lib/features/checkout/CheckoutSelector';

const ShippingOptionsCard = dynamic(
  () =>
    import(
      '@next-app/components/Checkout/ShippingOptionsCard/ShippingOptionsCard'
    ),
  {
    ssr: true,
    loading: () => <SkeletonUI width={'100%'} height={30} />,
  },
);

const ShippingSection = (): React.JSX.Element => {
  const isCheckoutDetailsLoaded = useSelector(selectIsCheckoutDetailsLoaded);
  const showShippingMethodStep =
    useSelector(selectShowShippingMethodStep) || false;
  const isPureDigitalOrder = useSelector(selectIsPureDigitalOrder);

  return (
    <>
      <Conditional if={!isCheckoutDetailsLoaded}>
        <SkeletonUI width={'100%'} height={30} />
      </Conditional>
      <Conditional
        if={
          isCheckoutDetailsLoaded &&
          !isPureDigitalOrder &&
          showShippingMethodStep
        }
      >
        <div id="shipping-section" className="my-md-ll-5">
          <ShippingOptionsCard />
        </div>
      </Conditional>
    </>
  );
};
export default ShippingSection;
